export default __webpack_public_path__ + "img/CaikumaElated.5623f553.webp";